<template>
  <div class="header-background">
    <!-- Fila para el botón en la parte superior derecha -->

    <!-- Fila de abajo para el logo y menú -->
    <div class="logo">
      <img
        src="../../assets/img/Landing/xtrim-pro-logo.png"
        alt="Logo XtrimPro"
      />
    </div>

    <nav class="menu d-flex justify-content-center">
      <div style="display: flex; justify-content: center; align-items: center">
        <!-- <a href="#inicio">INICIO</a></li> -->
        <a href="/login">REGÍSTRATE</a>
        <a href="#como-ganar">¿CÓMO GANAR?</a>
        <!-- <a href="#mapa">MAPA DE COBERTURA</a> -->
        <a href="#preguntas">PREGUNTAS FRECUENTES</a>
        <a href="#contacto">CONTÁCTANOS</a>
      </div>
    </nav>
    <div class="row justify-content-end align-items-center mb-2">
      <div class="mi-xtrimpro">
        <login-ingreso-desktop />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoginIngresoDesktop from "./LoginDesktop.vue";

export default {
  name: "Landig-Desktop",
  components: {
    LoginIngresoDesktop,
  },

  data() {
    return {};
  },
  computed: {},
  watch: {},

  activated() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.landing-header {
  width: auto;
  height: auto;
  background: radial-gradient(circle at top left, #cbbdfe, transparent 50%),
    radial-gradient(circle at bottom right, #cbbdfe, transparent 40%), #fff;
}

.header-background {
  background-image: url("../../assets/img/Landing/bloque-superior-web.png");
  background-size: cover;
  background-position: center;
  padding: 10px 0 10px 20px;
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

/* Ajuste del botón "Ingresar" */
.mi-xtrimpro {
  text-align: right;
  flex-shrink: 0;
  margin-left: auto;
}

.mi-xtrimpro .btn-ingresar {
  background-color: white;
  color: #800080;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;
}

.mi-xtrimpro .btn-ingresar:hover {
  background-color: #e0e0e0;
}

/* Logo */
.logo {
  flex-shrink: 0;
}

.logo img {
  height: 80px;
}

/* Menú */
.menu {
  text-align: center;
  flex: 1;
  min-width: 0;
  max-width: 100%;
}

.menu div {
  list-style: none;
  display: flex;
  gap: 20px;
  margin: 0;
  padding: 0;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
}

.menu div a {
  text-decoration: none;
  color: white;
  font-weight: bold;
  position: relative;
  padding-bottom: 5px;
  transition: color 0.3s ease;
  height: fit-content;
  white-space: nowrap;
}

.menu div a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: yellow;
  transition: width 0.3s ease;
}

.menu div a:hover {
  color: yellow;
}

.menu div a:hover::after {
  width: 100%;
}

/* Media queries para responsive */
@media (max-width: 1024px) {
  .header-background {
    padding: 10px 15px;
  }

  .logo img {
    height: 70px;
  }

  .menu div {
    gap: 15px;
  }

  .menu div a {
    font-size: 14px;
  }
}

@media (max-width: 900px) {
  .header-background {
    padding: 10px;
    gap: 8px;
  }

  .logo img {
    height: 60px;
  }

  .menu div {
    gap: 12px;
  }

  .menu div a {
    font-size: 13px;
  }
}

@media (max-width: 850px) {
  .header-background {
    padding: 8px;
    gap: 6px;
  }

  .logo img {
    height: 55px;
  }

  .menu div {
    gap: 10px;
  }

  .menu div a {
    font-size: 12px;
  }
}

@media (max-width: 790px) {
  .header-background {
    padding: 8px 10px;
    gap: 5px;
  }

  .logo img {
    height: 50px;
  }

  .menu {
    flex: 0 1 auto;
    min-width: 0;
  }

  .menu div {
    gap: 8px;
  }

  .menu div a {
    font-size: 11px;
  }

  .mi-xtrimpro {
    flex-shrink: 0;
  }
}

@media (max-width: 700px) {
  .header-background {
    padding: 6px 8px;
    gap: 4px;
  }

  .logo img {
    height: 45px;
  }

  .menu div {
    gap: 6px;
  }

  .menu div a {
    font-size: 10px;
  }
}

@media (max-width: 600px) {
  .header-background {
    padding: 5px;
    gap: 3px;
  }

  .logo img {
    height: 40px;
  }

  .menu div {
    gap: 5px;
  }

  .menu div a {
    font-size: 9px;
  }
}
</style>
